import consumer from "./consumer"

const cardImportChannelId = 'CardImportChannel'

const cardImportChannelMethods = {
  received(data){
    if(data.event === 'progressStart'){
      // swap indefinite for progress
      const indefiniteProgress = document.getElementById('import-starting')
      if(indefiniteProgress) indefiniteProgress.classList.add('hidden')

      const progressBar = document.getElementById('import-working')
      if(progressBar) progressBar.classList.remove('hidden')
    }

    if(data.event === 'progressUpdate'){
      // update width of the bar
      const progressBar = document.getElementById('import-working')
      if(progressBar) progressBar.firstElementChild.style.width = `${data.info.progress_percent}%`
    }
  }
}

export const conversationsChannel = consumer.subscriptions.create(cardImportChannelId, cardImportChannelMethods)
